import { AttributionLog, createAttribution } from './attributionLog';
import { DirectMailAttribution } from './attributionTypes';
import moment from 'moment';

export class IngressService {
  /**
   *

   * @param {localStorage} localStorage - localstorage engine to store attributions
   * @param {number} defaultTtl - a global default ttl for attributions
   * @param {string} storageKey - the localstorage key used to store attribution data
   */
  constructor (localStorage, defaultTtl, storageKey) {
    this.localStorage = localStorage;
    this.defaultTtl = defaultTtl;
    this.storageKey = storageKey || 'attribution';

    this.attributionLog = new AttributionLog(
      this.localStorage.get(this.storageKey, {})
    );

    this.actualAttribution = null;
  }

  /**
   * Applies attribution to log and stores to vuex and local store
   * @param queryService
   * @param cookieService
   */
  attribute (queryService, cookieService) {
    this._doAttributions(queryService);
  }

  attributeDirectMail ({ lenderId, promoCode, sponsorClickId }) {
    const attributedAt = moment().format();
    const directMailAttribution = new DirectMailAttribution({ sponsorClickId, attributedAt, lenderId });
    this.attributionLog.pushUnique(
      directMailAttribution
    );

    this.localStorage.set(this.storageKey, this.attributionLog);
    this.actualAttribution = this.attributionLog.getCurrentAttribution();
  }

  /**
   * takes the attribution data and compares to localStorage data and stores and returns appropriate attribution

   * @param queryService
   * @private
   */
  _doAttributions (queryService) {
    const attributionData = queryService.getAttributionData();
    const autopayData = queryService.getAutopayData();
    // [NOTE] leaving these here, waiting for discussions with product/marketing to use google standard utm
    // const utmData = queryService.getUtms();
    // const campaignData = queryService.getCampaignData(this.defaultTtl);

    const attributionRecord = createAttribution({
      ...attributionData,
      autopayData: autopayData
    });

    this.attributionLog.pushUnique(
      attributionRecord
    );

    this.localStorage.set(this.storageKey, this.attributionLog);
    this.actualAttribution = this.attributionLog.getCurrentAttribution();
  }

  /**
   * reset localStorage
   */
  clearStorage () {
    this.localStorage.set(this.storageKey, new AttributionLog({}));
  }
}
